import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";

import en from "./en/translations.json";
import fr from "./fr/translation.json";
import { convertLanguageJsonToObject } from "./translations";

export const translationsJson = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);
// console.log('LanguageDetector: ', LanguageDetector)
export const i18n = i18next
  .use(XHR)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      order: ["querystring", "navigator"],
      lookupQuerystring: "lng",
    },
    fallbackLng: "en",
    resources: translationsJson,
    supportedLngs: ["en", "fr"],
    interpolation: {
      escapeValue: false,
    },
  });
